import React from 'react';
import { Card } from '../../ui/card';
import ACCMagnitudeChart from './ACCMagnitudeChart';
import ACCIndexesChart from './ACCIndexesChart';
import { useTranslation } from '../../../locales';
import { useLanguageStore } from '../../../stores/languageStore';

const ACCVisualizer: React.FC = () => {
  const { currentLanguage } = useLanguageStore();
  const t = useTranslation(currentLanguage);

  return (
    <div className="space-y-6">
      {/* 제목 */}
      <Card className="p-4">
        <h2 className="font-medium mb-2">
          {t.visualizer.accTitle}
        </h2>
        <p className="text-sm text-muted-foreground">
          {t.visualizer.accDesc}
        </p>
      </Card>

      {/* 가속도 크기 차트 */}
      <Card className="p-4">
        <h3 className="font-medium mb-4">
          {t.visualizer.accMagnitude}
        </h3>
        <div className="text-sm text-muted-foreground mb-4">
          {t.visualizer.accMagnitudeDesc}
        </div>
        <div className="h-[320px]">
          <ACCMagnitudeChart />
        </div>
      </Card>

      {/* 종합 분석 지수 */}
      <Card className="p-4">
        <h3 className="font-medium mb-4">
          {t.visualizer.accIndexes}
        </h3>
        <div className="text-sm text-muted-foreground mb-4">
          {t.visualizer.accIndexesDesc}
        </div>
        <ACCIndexesChart />
      </Card>
    </div>
  );
};

export default ACCVisualizer;
